











































































/**
 * @copyright       Palace Resorts
 * @description     Pantalla principal de Reportes Proveedor
 * @author          cchan
 * @creationDate    20/09/2021
 */

import i18nMessages from "./i18n/messages";
import GlobalMixin from "@/mixins/global";
import ResponseData from "@/models/store/ProveedoresTypesData";
import dataService from "@/services/proveedoresAPI";
import BreadcrumbNav from "@/components/Breadcrumbs/BreadcrumbNav.vue";
import DatatableReport from "@/components/Reports/DatatableReport.vue";
export default GlobalMixin.extend({
  // Asignamos los mensajes del módulo al framework i18n, para el manejo del idioma
  i18n: i18nMessages,
  components: {
    // Incluimos lo componentes que utilizará este módulo
    BreadcrumbNav,
    DatatableReport,
  },
  data() {
    return {
      // GENERAL
      moduleName: "REPORTS_SUPPLIER",
      proveedorID: 0,
      // TABS
      tab: null,
      // total pendientes por subir
      totalP: 0,
      // total pendientes por autorizar
      totalPA: 0,
      // total rechazados
      totalR: 0,
      // DATATABLES
      // pendientes por subir
      headersMissingDoc: [],
      dataTableMissingDoc: [],
      loadingMissingDoc: true,
      // pendientes por autorizar
      headersPendingDoc: [],
      dataTablePendingDoc: [],
      loadingPendingDoc: true,
      // rechazados
      headersRefuseDoc: [],
      dataTableRefuseDoc: [],
      loadingRefuseDoc: true,
    };
  },
  methods: {
    // GENERAL
    init() {
      this.proveedorID = this.$store.getters['auth/userID'];
      // Pendientes por subir
      this.headersMissingDoc = [
        {
          text: "ID",
          value: "id",
        },
        {
          text: "Tipo de documento",
          value: "docTipo",
        },
      ];
      // Pendientes por autorizar
      this.headersPendingDoc = [
        {
          text: "ID",
          value: "id",
        },
        {
          text: "Tipo de documento",
          value: "docTipo",
        },
      ];
      // Rechazados
      this.headersRefuseDoc = [
        {
          text: "ID",
          value: "id",
        },
        {
          text: "Tipo de documento",
          value: "docTipo",
        },
        {
          text: "Motivo de Rechazo",
          value: "docMotivoRechazo",
        },
      ];
      // Proveedores con pendientes por subir
      //this.getReportMissingDocSupp();
      // Proveedores con pendientes por autorizar
      this.getReportPendingDocSupp();
      // Proveedores con documentos rechazados
      this.getReportRefuseDocSupp();
    },
    // Reporte de proveedores con documentos pendientes por subir
    async getReportMissingDocSupp() {
      dataService
        .getReportMissingDocSupp(this.proveedorID)
        .then((Response: ResponseData) => {
          this.totalP = Response.data.data[0].totalDocumentos;
          this.dataTableMissingDoc = Response.data.data[0].listaDocumentos;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.loadingMissingDoc = false));
    },
    // Reporte de proveedores con documentos pendientes por autorizar
    async getReportPendingDocSupp() {
      dataService
        .getReportPendingDocSupp(this.proveedorID)
        .then((Response: ResponseData) => {
          this.totalPA = Response.data.data[0].totalDocumentos;
          this.dataTablePendingDoc = Response.data.data[0].listaDocumentos;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.loadingPendingDoc = false));
    },
    // Reporte de proveedores con documentos rechazados
    async getReportRefuseDocSupp() {
      dataService
        .getReportRefuseDocSupp(this.proveedorID)
        .then((Response: ResponseData) => {
          this.totalR = Response.data.data[0].totalDocumentos;
          this.dataTableRefuseDoc = Response.data.data[0].listaDocumentos;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.loadingRefuseDoc = false));
    },
  },
  mounted() {
    this.init();
  },
});
